import React, { useState } from 'react';
import { Button, Space } from 'antd';
import VmDetailView from '../../../shared/components/evm/VmDetailView';
import evmAdminService from '../../../shared/services/evmAdminService';
import AdminTransferAction from '../../components/AdminTransferAction';
import AdminSubscriptionEditModal from '../../components/billing/AdminSubscriptionEditModal';
import AdminVmElasticModal from './AdminVmElasticModal';
import AdminVmExtrasModal from './AdminVmExtrasModal';

const VmsDetail = () => {
    const [elasticId, setElasticId] = useState(null);
    const [subId, setSubId] = useState(null);
    const [extrasId, setExtrasId] = useState(null);
    return (
        <>
            <VmDetailView
                mode="admin"
                api={evmAdminService}
                renderExtra={({ id, vm }) => (
                    <Space size={4}>
                        <Button size="middle" onClick={() => setElasticId(Number(vm.id || id))}>升降配</Button>
                        <Button size="middle" onClick={() => setExtrasId(Number(vm.id || id))}>附加项</Button>
                        {!!vm.subscription_id && <Button size="middle" onClick={() => setSubId(Number(vm.subscription_id))}>到期 / 续费</Button>}
                        <AdminTransferAction type="evm" id={Number(vm.id || id)} name={vm.hostname || vm.name} size="middle"
                            onDone={() => window.location.reload()} />
                    </Space>
                )}
            />
            <AdminVmElasticModal open={!!elasticId} vmId={elasticId} onClose={() => setElasticId(null)} onDone={() => {}} />
            <AdminVmExtrasModal open={!!extrasId} vmId={extrasId} onClose={() => setExtrasId(null)} />
            <AdminSubscriptionEditModal open={!!subId} subscriptionId={subId} onClose={() => setSubId(null)} onSaved={() => window.location.reload()} />
        </>
    );
};

export default VmsDetail;
